import React, { useEffect } from "react";
import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import CheckImg from "../../../assets/images/common/checkVector.svg";
import CrossImg from "../../../assets/images/common/crossGroup.svg";
import CustomButton from "../../../assets/components/CustomButton";
import Confetti from "react-confetti";
import CuurectSound from "../../../assets/Audio/win.mp3";
import FlaseSound from "../../../assets/Audio/lose.mp3";
import { useDispatch } from "react-redux";
import UsersRequests from "../../../assets/services/user";

const WordGameFinalizeDialog = ({ open, handleClose, type, message }) => {
  const winAudio = new Audio(CuurectSound);
  const lossAudio = new Audio(FlaseSound);
  const dispatch = useDispatch();

  useEffect(() => {
    const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));
    if (open && soudMuted) {
      if (type === "correct") {
        winAudio.play();
      } else {
        lossAudio.play();
      }
    }
  }, [open]);

  const rightAnswerDialog = (
    <div className="w-100 text-center">
      <img src={CheckImg} alt="check-vector" className={classes.alertBanner} />
      <p className={classes.title}>پاسخ صحیح</p>
      <div className={classes.dialogContent}>
        <p className="text-center">{message}</p>
      </div>
      <div className="w-100 mt-4">
        <CustomButton
          clickHandler={() => {
            handleClose();
            dispatch(UsersRequests.getUserPoint());
          }}
          color={"primary"}
          shadow
          text={"بستن"}
        />
      </div>
    </div>
  );

  const falseAnswerDialog = (
    <div className="w-100">
      <img src={CrossImg} alt="check-vector" className={classes.alertBanner} />
      <p className={classes.title}>پاسخ اشتباه</p>
      <div className={classes.dialogContent}>
        <p className="text-center">{message}</p>
      </div>
      <div className="w-100 mt-4">
        <CustomButton
          clickHandler={handleClose}
          color={"primary"}
          shadow
          text={"بستن"}
        />
      </div>
    </div>
  );

  return (
    <>
      <CustomModal
        open={open}
        closeHandler={handleClose}
        inputDialog={true}
        dialogContent={
          type === "correct" ? rightAnswerDialog : falseAnswerDialog
        }
      />
      {open && type == "correct" ? (
        <Confetti width={window.innerWidth} height={window.innerHeight} />
      ) : null}
    </>
  );
};

export default WordGameFinalizeDialog;
